import {Component} from '@angular/core';

import {ObjectLayoutWidget} from '../../widget';

@Component({
  selector: 'sf-form-object',
  templateUrl: './sf-object-widget.component.html',
})
export class ObjectWidgetComponent extends ObjectLayoutWidget {
}



// WEBPACK FOOTER //
// ./src/app/schema-form/components/defaultwidgets/object/sf-object-widget.component.ts